import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/btc': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M310.2 242.6c46 11 75 38.4 69.3 99.9-7.2 76.6-61.6 97.1-142.9 101.5v68h-48.5v-66.7c-12.3 0-25.2 0-38.4-0.3v67.1h-48.5v-68s-8.9-0.3-97.4-0.3l9.8-57.7c34.7 0.6 50.3 3.4 53.3-16.1v-217.4c-4.6-24.6-24.7-22.1-63-21.4v-51.7c58.7 0.3 79.5 0.5 97.4 0v-79.4h48.5v77.8c12.9-0.3 25.8-0.6 38.4-0.6v-77.2h48.5v79.4c62.4 5.4 109.5 24.6 114.9 81.9 4.1 41.9-13.6 67.1-41.3 81.3zM150.6 134.6v96.7c27.4 0 113.1 6.3 113.1-48.2 0-57-85.7-48.5-113.1-48.5zM150.6 386.3c32.8 0 133.1 6.9 133.1-53.3 0-62.4-100.4-53.3-133.1-53.3v106.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/btc.js
// module id = 738
// module chunks = 0